/**
 * ProtectedClientRoutes
 *
 * Guards routes that are exclusively for CUSTOMER users (/home, /reviews, etc.).
 * - Unauthenticated users → redirect to /login.
 * - Authenticated users with an admin-type role → redirect to /admin
 *   (they have no business on customer pages).
 * - Authenticated CUSTOMER users → render the outlet normally.
 */
import { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LoadingContainer } from "./styles";
import useUserStore from "../../store/user";
import { isAdminRole } from "../../permissions";

export const ProtectedClientRoutes = () => {
  const { user } = useUserStore();

  const LoadingComp = () => (
    <LoadingContainer>
      <div className="loading">
        <h1 className="lbl">Carregando...</h1>
      </div>
    </LoadingContainer>
  );

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Admin-type users who somehow land on a client route are redirected
  // to their proper landing page instead of seeing a broken experience.
  if (isAdminRole(user.userType)) {
    return <Navigate to="/admin" />;
  }

  return (
    <Suspense fallback={<LoadingComp />}>
      <Outlet />
    </Suspense>
  );
};
